import React from 'react'
import useMobile from "../../../shared/hooks/useMobile";
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { GatsbyImage } from 'gatsby-plugin-image'
import './section-radio-show-and-forum-header.scss'

const SectionRadioShowAndForumHeader = ({ contentInfo }) => {

    const mobile = useMobile()

    const description = {
        renderNode: {
            [BLOCKS.HEADING_2]: (node, next) => <h2 className="f-m-radio-show-and-forum-header__subtitle">{next}</h2>,
            [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-m-radio-show-and-forum-header__paragraph">{next}</p>,
            [INLINES.HYPERLINK]: (node, next) => <a className="f-m-radio-show-and-forum-header__paragraph __link" href={(node.data.uri.includes('https') || node.data.uri.includes('www')) ? (node.data.uri) : (homeLink + node.data.uri)} rel="noopener noreferrer" target="_blank">{next}</a>
        }
    };

    return (
        <section className="f-m-radio-show-and-forum-header">
            <div className="f-m-radio-show-and-forum-header__content">
                <div className="f-m-radio-show-and-forum-header__text">
                    <h1 className="f-m-radio-show-and-forum-header__title">{contentInfo.tituloGeneral}</h1>
                    {contentInfo.descripcion && contentInfo.descripcion.raw && documentToReactComponents(JSON.parse(contentInfo.descripcion.raw), description)}
                </div>
                {(!mobile && contentInfo.imagen) &&
                    <div className="f-m-radio-show-and-forum-header__main-image-container">
                        <GatsbyImage
                            image={contentInfo.imagen[0].gatsbyImageData}
                            alt={contentInfo.imagen[0].description}
                            className="f-m-radio-show-and-forum-header__main-image"
                        />
                    </div>
                }
            </div>
        </section>
    )
}

export default SectionRadioShowAndForumHeader
